import {Component, effect, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatSidenavModule} from "@angular/material/sidenav";
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType} from "keycloak-angular";
import {RealmService} from "./keycloak/services/realm.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    MatSidenavModule,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor() {
    const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
    const realmService = inject(RealmService)

    effect(async () => {
      const keycloakEvent = keycloakSignal();

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        await realmService.clearStorage()
      }
    });
  }
}
